import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { FAQ as FAQAccordion } from './utils';
import { useStyles } from './style';

interface FaqGridProps {
  questions: {
    question: string;
    answer: string;
  }[];
}

export const FaqGrid = ({ questions }: FaqGridProps) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = 
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };


  return (
    <div className={classes.accordionContainer}>
      <Grid container sx={{ mb: 4, gridAutoFlow: 'column' }}>
        {questions.map((question, index) => (
          <FAQAccordion
            key={index}
            expanded={expanded === `panel${index + 1}`}
            onChange={handleChange(`panel${index + 1}`)}
            question={question.question}
            answer={question.answer}
          />
        ))}
      </Grid>
    </div>
  );
};

export default FaqGrid;
